export const visitorList = "VISITOR_LIST";
export const visitorDetails = "VISITOR_DETAILS";